<div class="wrapper" *ngIf="document">
  <div class="header">
    <img
      class="logo"
      [src]="document.logo.data.attributes.url"
      alt="endsleigh logo"
    />
  </div>

  <div class="body">
    <h1>Maintenance page</h1>
    <div class="line"></div>
    <div class="body-wrapper">
      <h1>{{ document.title }}</h1>
      <div class="content">
        <p>{{ document.content }}</p>
      </div>
    </div>
  </div>
</div>
